import React from 'react'
import styles from '../../assets/styles/styles.module.css'
import { RatingContext } from '../../utils/RatingContext'
import { CONSTANTS } from '../../utils/Constants'

export const StarIcon = (props: any): React.ReactElement => {
    const { fill = 'none' } = props
    const error = React.useContext(RatingContext).formError
  
    const stroke = error ? CONSTANTS['starHoverColor'] : 'none'
  
    return (
      <svg viewBox='0 0 20 20' className={styles.svg} version='1.1'>
        <defs>
          <polygon
            id='star-1'
            points='2 9.36357553 8.77685045 8.25760978 12.3374065 2 15.5306245 8.25760978 22 9.36357553 17.4351156 15.2404218 18.6117986 22 12.3374065 18.3340062 6.08236905 22 6.70350904 15.2404218'
          />
          <filter
            x='-7.5%'
            y='-7.5%'
            width='115.0%'
            height='115.0%'
            filterUnits='objectBoundingBox'
            id='filter-2'
          >
            <feGaussianBlur
              stdDeviation='1'
              in='SourceAlpha'
              result='shadowBlurInner1'
            />
            <feOffset
              dx='0'
              dy='1'
              in='shadowBlurInner1'
              result='shadowOffsetInner1'
            />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
        </defs>
        <g
          id='star_outline'
          stroke={stroke}
          strokeWidth='1'
          fill='none'
          fillRule='evenodd'
        >
          <g id='star' transform='translate(-2.000000, -2.000000)'>
            <use fill={fill} fillRule='evenodd' href='#star-1' />
            <use
              fill='black'
              fillOpacity='1'
              filter='url(#filter-2)'
              href='#star-1'
            />
          </g>
        </g>
      </svg>
    )
  }